import React, { FC } from 'react';

export interface GenerateDocumentProps {
  handleDocument: () => void;
  disabled?: boolean;
}

export const GenerateDocument: FC<GenerateDocumentProps> = ({ handleDocument, disabled }) => {
  return (
    <div className="tag-ds " style={{ marginLeft: 8 }}>
      <button className="button-secondary" onClick={handleDocument} disabled={disabled}>
        <span className="material-icons">create_new_folder</span>
      </button>
    </div>
  );
};
